/**
 * Created by ivan on 06.04.18.
 */

const BurstCellView = BaseCellView.extend({ 
    ctor: function (burstCell) {
        this._super();

        this.setContentSize(cleverapps.styles.BaseCellView.CELL_SIZE_PX, cleverapps.styles.BaseCellView.CELL_SIZE_PX);
        this.setAnchorPoint(0.5, 0.5);

        const image = new cc.Sprite(this.getImage(burstCell.lives));
        this.image = image;
        this.image.setPosition(this.width / 2, this.height / 2);
        this.addChild(image);

        this.animation = new cleverapps.Spine(bundles.burst.jsons.burst_json);
        this.animation.setPosition(this.width / 2, this.height / 2);
        this.animation.setStartVisibleListener(() => {
            this.image.visible = false;
        });
        this.addChild(this.animation);

        this.initialize(burstCell);
    },

    getImage: function (lives) {
        lives = lives || this.cell.lives;
        return bundles.burst.frames[`burst_${4 - lives}`];
    },

    updateImage: function () {
        const image = this.getImage();
        if (image === undefined) {
            return;
        }
        this.image.setSpriteFrame(image);
    },

    initialize: function (burstCell) {
        this._super(burstCell);

        this.image.setVisible(true);
        this.animation.setVisible(false);

        burstCell.onChangeLivesListener = this.createListener(this.changeLives.bind(this));
        burstCell.onBurstListener = this.createListener(this.burstAnimation.bind(this));
    },

    animate: function (name, cycle, onFinish) {
        this.animation.setAnimation(0, name, cycle);
        this.animation.setCompleteListener(onFinish);
    },

    finishAnimation: function () {
        this.updateImage();
        this.image.setVisible(true);
        this.animation.setVisible(false);
    },

    changeLives: function () {
        if (this.cell.lives > 0) {
            if (this.cell.lives < BurstCell.MAX_LIVES) {
                this.animate(`${BurstCell.MAX_LIVES - this.cell.lives}`, false, this.finishAnimation.bind(this));
            } else {
                this.updateImage();
            }
        } else {
            this.animate("4_idle", true, () => {});
        }

        if (bundles.burst.urls.burst_fill_effect) {
            cleverapps.effects.fire("burst.fill");
        }
    },

    unuse: function () {
        this.cell.onChangeLivesListener = function () {};

        this._super();
    },

    openAnimation: function () {
        const realZOrder = this.getLocalZOrder();
        this.setLocalZOrder(2);
        this.animate("open", false, () => {
            this.setLocalZOrder(realZOrder);
        });

        const styles = cleverapps.styles.BurstCellView;
        this.runAction(new cc.Sequence(
            new cc.DelayTime(styles.openSound.delay),
            new cc.CallFunc(() => {
                cleverapps.effects.fire("match3.burstcell.open");
            })
        ));
    },

    burstAnimation: function (targetCell, id) {
        const colors = ["purple", "yellow", "green", "red", "blue"];
        const ball = new cc.Sprite(bundles.burst.frames[`ball_${colors[id]}`]);
        ball.setOpacity(0);
        this.parent.addChild(ball);
        ball.setAnchorPoint(0.5, 0.5);
        ball.setPosition(this.getPosition());
        ball.y -= cleverapps.styles.BaseCellView.CELL_SIZE_PX / 2;
        const FADE_TIME = 0.1;
        const delayTime = id * BurstCell.BURST_INTERVAL;
        const burstDuration = this.cell.burstDuration(targetCell, id);
        const targetPosition = BaseCellView.alignInTheGrid(targetCell.x, targetCell.y);
        ball.runAction(new cc.Sequence(
            new cc.DelayTime(delayTime),
            new cc.Spawn(
                new cc.FadeIn(FADE_TIME),
                new cc.MoveTo(burstDuration - delayTime, targetPosition).easing(cc.easeQuadraticActionIn()),
                new cc.CallFunc(() => {
                    cleverapps.effects.fire("match3.bomb.left_moves.explosion");
                }),
                new cc.Sequence(
                    new cc.ScaleTo((burstDuration - delayTime) / 2, 1.8),
                    new cc.ScaleTo((burstDuration - delayTime) / 2, 1.3)
                ),
                new cc.Sequence(
                    new cc.DelayTime(burstDuration - delayTime - FADE_TIME),
                    new cc.FadeOut(FADE_TIME)
                )
            ),
            new cc.RemoveSelf()
        ));

        this.runAction(new cc.Sequence(
            new cc.DelayTime(burstDuration),
            new cc.CallFunc(() => {
                const blastAnimation = BlastAnimation.factory(colors[id]);
                blastAnimation.setPosition(targetPosition);
                blastAnimation.setLocalZOrder(10);
                this.parent.addChild(blastAnimation);
                blastAnimation.runAnimate("animation");
            })
        ));
    },

    hurtAnimation: function () {
    }
});

cleverapps.styles.BurstCellView = {
    openSound: {
        delay: 0.4
    }
};